/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module textindent/indentText
 */
import Plugin from '@src/plugins/ckeditor5-core/src/plugin';
import IndentTextCommand from './indentTextCommand';
import RemoveIndentTextCommand from './removeIndentTextCommand';
import first from '@src/plugins/ckeditor5-utils/src/first';
import './index.css';
export default class IntendText extends Plugin {
	static get pluginName() {
		return 'TextIndent';
	}

	init() {
		const editor = this.editor;
		editor.commands.add( 'indentText', new IndentTextCommand( editor ) );
		editor.commands.add( 'removeIndentText', new RemoveIndentTextCommand( editor ) );
		const getCommandExecuter = commandName => {
			return ( data, cancel ) => {
				const command = this.editor.commands.get( commandName );
				const selection = editor.model.document.selection;
				// 缩进对表格内对文字不起作用
				let tableCell = getTableCellsContainingSelection( selection )[ 0 ];
				if ( !tableCell ) {
					tableCell = this.editor.plugins.get( 'TableSelection' ).getFocusCell();
				}
				if ( tableCell ) {
					return;
				}

				if ( command.isEnabled ) {
					if ( selection.isCollapsed && selection.anchor.offset === 0 ) {
						this.editor.execute( commandName );
					}
					cancel();
				}
			};
		};
		// const indentTextCommand = editor.commands.get( 'indentText' );
		editor.keystrokes.set( 'Tab', getCommandExecuter( 'indentText' ) );
		editor.conversion.attributeToAttribute( {
			model: {
				key: 'indentText',
				values: [ 'textIndent' ]
			},
			view: {
				textIndent: {
					key: 'class',
					value: 'ck-textindent'
				}
			}
		} );

		const view = editor.editing.view;

		// Detect pressing `Backspace` / `Delete`.
		this.listenTo( view.document, 'delete', ( evt, data ) => {
			// deletedContent = true;
			const selection = editor.model.document.selection;
			const block = first( editor.model.document.selection.getSelectedBlocks() );
			if ( selection.isCollapsed && selection.anchor.offset === 0 && block.getAttribute( 'indentText' ) ) {
				editor.execute( 'removeIndentText' );
				data.preventDefault();
				evt.stop();
			}
		}, { priority: 'high' } );
		// this.listenTo( editor.model, 'deleteContent', () => {
		// 	const selection = editor.model.document.selection;
		// 	console.log( selection.isCollapsed );
		// 	console.log( selection.anchor.offset );
		// }, { priority: 'high' } );
	}
	afterInit() {
		const editor = this.editor;
		const schema = editor.model.schema;
		schema.extend( 'paragraph', { allowAttributes: 'indentText' } );

		schema.setAttributeProperties( 'indentText', { idFormatting: true } );
	}
}

function getTableCellsContainingSelection( selection ) {
	const cells = [];

	for ( const range of selection.getRanges() ) {
		const cellWithSelection = range.start.findAncestor( 'tableCell' );

		if ( cellWithSelection ) {
			cells.push( cellWithSelection );
		}
	}

	return cells;
}
